import { render } from "./MyVouchersForMerchantPage.vue?vue&type=template&id=fa9ba342&scoped=true"
import script from "./MyVouchersForMerchantPage.vue?vue&type=script&lang=js"
export * from "./MyVouchersForMerchantPage.vue?vue&type=script&lang=js"

import "./MyVouchersForMerchantPage.vue?vue&type=style&index=0&id=fa9ba342&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa9ba342"]])

export default __exports__